import React from 'react';
import { BsCheckLg, BsExclamationTriangleFill } from 'react-icons/bs';

import { Invoice } from 'entities/Invoice';

import { format } from 'utils/format';
import { isReportOvercharge } from 'utils/audit';

import { Pill } from './audit-pill.styles';

/**
 * Auditoria por fatura: alerta + valor a mais em laranja (link para o
 * relatório) quando a divergência é material, "ok" em verde quando não, "-" sem
 * auditoria gravada. Visual na identidade do app desde 27/out/2026. Usada no modal "Minhas faturas" do Dashboard e, desde
 * out/2026, na aba Faturas da UC (revisão de UX — a aba não tinha a coluna).
 */
export const AuditPill = ({
  invoice,
}: {
  invoice: Pick<Invoice, 'id' | 'invoiceValue' | 'auditSummary'>;
}) => {
  const summary = invoice.auditSummary;

  if (!summary) return <>-</>;

  if (
    summary.status === 'divergent' &&
    isReportOvercharge(summary.overcharge, invoice.invoiceValue)
  ) {
    return (
      <Pill
        $divergent
        href={`${process.env.REACT_APP_URL}/relatorio/${invoice.id}`}
        target="_blank"
        rel="noreferrer"
        title="Possível cobrança a mais — ver a auditoria no relatório"
      >
        <BsExclamationTriangleFill aria-hidden />
        R$ {format.money(summary.overcharge)}
      </Pill>
    );
  }

  return (
    <Pill $divergent={false} as="span">
      <BsCheckLg aria-hidden />
      ok
    </Pill>
  );
};
